var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0" },
    [
      _c(
        "v-col",
        {
          staticClass: "card-dashboard-details__item text-center py-0 my-0",
          attrs: { cols: "12", md: "12" }
        },
        [
          _c(
            "v-card-subtitle",
            { staticClass: "overline justify-center pt-0 mt-0 mb-1 pb-1" },
            [_c("h4", { domProps: { innerHTML: _vm._s(_vm.dataCenter) } })]
          ),
          _c("h3", { staticClass: "font-weight-light" }, [
            _vm._v(" " + _vm._s(_vm.timeAverageText) + " ")
          ]),
          _c(
            "h5",
            { staticClass: "font-weight-light pt-1 card--content__color" },
            [_vm._v(" " + _vm._s(_vm.getTimeDifference()) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }